module.exports = __webpack_public_path__ + "img/Group13.2588a454.png";